// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
  background: var(--ion-color-primary);
  border-radius: 60px;
}
.quantity-selector > * {
  line-height: var(--quantity-selector-height);
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  background-color: var(--color-white);
  border: 1px solid var(--ion-color-tertiary);
  line-height: 28.8px;
  text-align: center;
}
.circle span {
  font-family: AppFontSemiBold;
  font-size: calc(var(--quantity-font-size) * 1.4);
  color: var(--ion-color-primary-text);
  line-height: 9px;
  line-height: 15px;
  margin-bottom: 2px;
}
.circle.minus {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.circle.plus {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.rectangle {
  background: var(--color-white) !important;
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
  border-top: 1px solid var(--ion-color-tertiary);
  border-bottom: 1px solid var(--ion-color-tertiary);
}
.rectangle span {
  font-family: AppFontSemiBold;
  font-size: var(--quantity-font-size);
  line-height: 24px;
  text-align: center;
  color: var(--ion-color-primary-text);
}

.cart-screen > * {
  background: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,oDAAA;EACA,oCAAA;EACA,mBAAA;AACD;AACC;EAEC,4CAAA;EACA,UAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAaA;EACC,sCAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AAVD;AAWC;EACC,4BAAA;EACA,gDAAA;EAEA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAVF;AAaC;EACC,2BAAA;EACA,8BAAA;AAXF;AAcC;EACC,4BAAA;EACA,+BAAA;AAZF;;AAgBA;EACC,yCAAA;EACA,gDAAA;EACA,uCAAA;EACA,+CAAA;EACA,kDAAA;AAbD;AAeC;EACC,4BAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAbF;;AAkBC;EACC,8BAAA;AAfF","sourcesContent":[".quantity-selector {\n\tdisplay: flex;\n\tfont-size: calc(var(--quantity-selector-height) / 2);\n\tbackground: var(--ion-color-primary);\n\tborder-radius: 60px;\n\n\t> * {\n\t\t// background: #c6aa7a;\n\t\tline-height: var(--quantity-selector-height);\n\t\tpadding: 0;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t// &:first-child {\n\t\t// \tborder-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\n\t\t// &:last-child {\n\t\t// \tborder-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\t}\n}\n\n.circle {\n\twidth: var(--quantity-selector-height);\n\theight: var(--quantity-selector-height);\n\tcursor: pointer;\n\tbackground-color: var(--color-white);\n\tborder: 1px solid var(--ion-color-tertiary);\n\tline-height: 28.8px;\n\ttext-align: center;\n\tspan {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: calc(var(--quantity-font-size) * 1.4);\n\n\t\tcolor: var(--ion-color-primary-text);\n\t\tline-height: 9px;\n\t\tline-height: 15px;\n\t\tmargin-bottom: 2px;\n\t}\n\n\t&.minus {\n\t\tborder-top-left-radius: 4px;\n\t\tborder-bottom-left-radius: 4px;\n\t}\n\n\t&.plus {\n\t\tborder-top-right-radius: 4px;\n\t\tborder-bottom-right-radius: 4px;\n\t}\n}\n\n.rectangle {\n\tbackground: var(--color-white) !important;\n\twidth: calc(1 * var(--quantity-selector-height));\n\theight: var(--quantity-selector-height);\n\tborder-top: 1px solid var(--ion-color-tertiary);\n\tborder-bottom: 1px solid var(--ion-color-tertiary);\n\n\tspan {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: var(--quantity-font-size);\n\t\tline-height: 24px;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-primary-text);\n\t}\n}\n\n.cart-screen {\n\t> * {\n\t\tbackground: var(--color-white);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
